import React from 'react';
import { Row, Col, Form, Input, Select, Button, Grid } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTheme } from 'styled-components';

import {
    getLabelRoles,
    listAdminRoles,
    listUsersRoles,
} from '../../../interfaces/Roles';
import { ISearchData } from './types';

type IProps = {
    setSearch: (value: ISearchData) => void;
};

const Search: React.FC<IProps> = ({ setSearch }) => {
    const [form] = Form.useForm();
    const breakpoints = Grid.useBreakpoint();
    const theme = useTheme();

    const getRoleSelectOptions = () => {
        const enumArr = listUsersRoles().map((value) => {
            return { value, label: getLabelRoles(value) };
        });
        return [...enumArr];
    };

    const onSubmit = () => {
        const values = form.getFieldsValue(true);
        setSearch({ email: values.email, role: values.role });
    };

    const onReset = () => setSearch({ email: '', role: '' });

    return (
        <Row
            style={{
                borderBottom: `2px solid ${theme.colors.lightGrey}`,
                paddingBottom: '1.5rem',
            }}
        >
            <Col span={24}>
                <Form
                    form={form}
                    onFinish={onSubmit}
                    onReset={onReset}
                    layout="vertical"
                >
                    <Row>
                        <Col xs={24} sm={10} md={10} lg={8} xl={8} xxl={6}>
                            <Form.Item label="E-mail" name="email">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col
                            offset={breakpoints.sm ? 1 : 0}
                            xs={24}
                            sm={10}
                            md={10}
                            lg={8}
                            xl={8}
                            xxl={6}
                        >
                            <Form.Item label="Permissão" name="role">
                                <Select options={getRoleSelectOptions()} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[0, 10]}>
                        <Col xs={24} sm={8} md={8} lg={6} xl={6} xxl={4}>
                            <Button
                                htmlType="submit"
                                className="default-btn"
                                icon={<SearchOutlined />}
                                type="primary"
                                style={{ width: '100%' }}
                            >
                                Pesquisar
                            </Button>
                        </Col>
                        <Col
                            xs={{ span: 24, offset: 0 }}
                            sm={{ span: 8, offset: 1 }}
                            md={{ span: 8, offset: 1 }}
                            lg={{ span: 6, offset: 1 }}
                            xl={{ span: 6, offset: 1 }}
                            xxl={{ span: 4, offset: 1 }}
                        >
                            <Button
                                htmlType="reset"
                                danger
                                style={{ width: '100%' }}
                            >
                                Limpar
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
};

export default Search;
